import client from './client';

// 두피 진단 단일 결과 불러오기
export const getScalpResult = ({ user_id, diagnosis_id }) =>
  client
    .get('/my/user/' + user_id + '/scalp/v2/diagnosis/' + diagnosis_id)


// 두피 진단 히스토리 불러오기
export const getScalpHistory = ({
  user_id,
  diagnosis_item_type,
  scalp_point,
  skip,
  take,
}) => {
  return client
    .get(
      `/my/user/${user_id}/scalp/v2/histories?diagnosis_item_type=${diagnosis_item_type}&scalp_point=${scalp_point}&skip=${skip}&take=${take}`,
    )
};

// 두피진단 + 문진 보정 두피타입 및 두피이슈 조회
export const getScalpType = ({ user_id, diagnosis_items }) =>
  client
    .post(
      '/my/user/' + user_id + '/scalp/diagnosis/scalp-types',
      diagnosis_items,
    )


// 두피 분석 히스토리 원형 그래프 초기화 추후 API 생성됌
export const initGraphData = ({ user_id }) => {
  return client.get('/my/user/' + user_id + '/scalp/diagnoses?limit=4');
};
// 두피 분석 히스토리 원형 그래프 데이터 불러오기 추후 API 생성됌
export const getGraphData = ({ user_id }) => {
  return client.get('/my/user/' + user_id + '/scalp/diagnoses?limit=4');
};
